import { getLogger as getCoreLogger } from "@nrk/player-core/utils";
function getLogger(namespace) {
  return getCoreLogger(namespace);
}
export {
  getLogger
};
